import { render } from "./VF-menu.vue?vue&type=template&id=0babfb06"
import script from "./VF-menu.vue?vue&type=script&lang=js"
export * from "./VF-menu.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__